import Spinner from '@/components/atom/spinner';
import { LoaderContainer } from '@/components/molecules/loader/styles';

const Loader = (props: { size?: number }) => {
  return (
    <LoaderContainer>
      <Spinner size={props.size} />
    </LoaderContainer>
  );
};
export default Loader;
